<template>
  <v-select
    v-model="selectedSource"
    :loading="isLoading"
    :disabled="isLoading"
    outlined
    dense
    label="Payment Method"
    :items="items"
    :item-text="itemText"
    item-value="id"
    hide-details
    @change="onChangeSource"
  />
</template>
<script>
import { get } from 'lodash'
import { mapActions } from 'vuex'

export default {
  props: {
    isPlatform: {
      type: Boolean,
      default: false
    },
    customer: {
      type: Object,
      default: () => ({})
    },
    initSelected: {
      type: String,
      default: ''
    }
  },
  watch: {
    customer: {
      deep: true,
      handler() {
        this.loadCustomerWithSources()
      }
    }
  },
  data() {
    return {
      isLoading: false,
      defaultSource: null,
      selectedSource: null,
      sources: []
    }
  },
  computed: {
    items() {
      return this.sources
    }
  },
  mounted() {
    this.selectedSource = this.initSelected

    this.loadCustomerWithSources()
  },
  methods: {
    ...mapActions([ 'listCustomerPaymentMethods' ]),
    onChangeSource() {
      this.$emit('change-source', this.selectedSource)
    },
    itemText(item) {
      let card = null
      let bank = null
      let id = item.id

      if ((item.object === 'source' || item.object === 'payment_method') && item.type === 'card') {
        // Lastest way stripe handles payment sources
        card = item.card
      } else if (item.object === 'card') {
        // Backwards compatible case
        card = item
      } else if (item.object === 'bank_account') {
        // Backwards compatible case
        bank = item
      }

      if (card) {
        return `**** ${card.last4}\xa0\xa0\xa0\xa0${card.exp_month} / ${card.exp_year} ${id === this.defaultSource ? '(default)' : ''}`
      } else if (bank) {
        return `${bank.bank_name} **** ${bank.last4}`
      } else {
        return ''
      }
    },
    loadCustomerWithSources() {
      if (this.customer.id) {
        this.isLoading = true

        const loadPayload = {
          query: {
            customer: this.customer.id,
            limit: 100
          }
        }

        if (this.isPlatform) {
          loadPayload._headers = {
            'x-account': ''
          }
        }

        this.listCustomerPaymentMethods(loadPayload)
          .then(result => {
            this.sources = result.data
            this.defaultSource = get(this.customer, 'invoice_settings.default_payment_method')
              || get(this.customer, 'default_source')

            // Only assign if there is no source selected. Then use the customers default.
            if (this.defaultSource && !this.selectedSource) {
              this.selectedSource = this.defaultSource
              this.onChangeSource()
            }
          })
          .finally(() => {
            this.isLoading = false
          })
      }
    }
  }

}
</script>
